import { GamePack } from '@/API';
import PromptSelectionCard from '@/components/GamePacks/Prompts/PromptSelectionCard';
import { Prompt } from '@/models/Prompt.model';
import React, { useMemo } from 'react';

export type PromptExtended = Prompt & { gamePack?: GamePack };

interface PromptListListProps {
  title: string;
  prompts: PromptExtended[];
  selectedPrompts: PromptExtended[];
  setSelectedPrompts: React.Dispatch<React.SetStateAction<PromptExtended[]>>;
  removeable?: boolean;
  disabled?: boolean;
}

export default function PromptList({
  title,
  prompts,
  setSelectedPrompts,
  removeable,
  disabled,
  selectedPrompts
}: PromptListListProps) {
  const sortedPrompts = useMemo(() => {
    return prompts.sort((a, b) => {
      return a.text.localeCompare(b.text);
    });
  }, [prompts]);

  return (
    <>
      <p className="text-h2 mb-24 text-neutral-500">{title}</p>
      <div className={`flex flex-col gap-16 @8xl:flex-row @8xl:flex-wrap`}>
        {sortedPrompts.map((prompt) => {
          const selected = selectedPrompts.some(
            (selectedPrompt) => selectedPrompt.id === prompt.id
          );

          return (
            <PromptSelectionCard
              text={prompt.text}
              onRemove={() => {
                setSelectedPrompts((prev) => prev.filter((p) => p.id !== prompt.id));
              }}
              onClick={() => {
                if (disabled && !selected) return;

                if (selected) {
                  setSelectedPrompts(
                    selectedPrompts.filter((selectedPrompt) => selectedPrompt.id !== prompt.id)
                  );
                  return;
                }

                setSelectedPrompts((prev) => [...prev, prompt]);
              }}
              removeable={removeable && !disabled}
              disabled={disabled && !selected}
              selected={selected}
              key={prompt.id}
            />
          );
        })}
      </div>
    </>
  );
}
